// utils/extensions.js
String.prototype.toTime = function (lang, addHours = 0) {
  if (!this) return '';

  const date = new Date(`1970-01-01T${this}`);
  date.setHours(date.getHours() + addHours);

  return date.toLocaleTimeString([], {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  })
  .replace("AM", lang === "ar" ? "ص" : "AM")
  .replace("PM", lang === "ar" ? "م" : "PM");
};
String.prototype.toDate = function () {
  if (!this) return "";

  const date = new Date(this);

  if (isNaN(date.getTime())) return ""; // invalid date

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // month is 0-based
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}
Number.prototype.toPackageTimeUnit = function () {
  switch (this.valueOf()) {
    case 1:
      return "Days";

    case 2:
      return "Hours";

    default:
      return "";
  }
};
String.prototype.toReadableText = function () {
  return this.replace(/([A-Z])/g, " $1").trim();
};
Date.prototype.toISODateString = function () {
  const year = this.getFullYear();
  const month = String(this.getMonth() + 1).padStart(2, "0");
  const day = String(this.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};
String.prototype.toChatDate = function (
  lang = "en",
  mode = "conversation" // conversation | message
) {
  if (!this) return "";

  // FIX: Force JavaScript to treat the ISO string as UTC by adding 'Z'
  let dateString = this.trim();
  if (!dateString.endsWith("Z")) {
    dateString += "Z";
  }

  const date = new Date(dateString);
  const now = new Date();

  if (isNaN(date.getTime())) return "";

  const locale = lang === "ar" ? "ar-SA" : "en-US";

  const timeOptions = {
    hour: "numeric",
    minute: "2-digit",
    hour12: true
  };

  // Message bubble => always show time
  if (mode === "message") {
    return date.toLocaleTimeString(locale, timeOptions);
  }

  // Today
  const isToday =
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate();

  if (isToday) {
    return date.toLocaleTimeString(locale, timeOptions);
  }

  // Yesterday
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);

  const isYesterday =
    date.getFullYear() === yesterday.getFullYear() &&
    date.getMonth() === yesterday.getMonth() &&
    date.getDate() === yesterday.getDate();

  if (isYesterday) {
    return lang === "ar" ? "أمس" : "Yesterday";
  }

  // Calendar days difference
  const startOfNow = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const daysDiff = Math.round((startOfNow - startOfDate) / (1000 * 60 * 60 * 24));

  if (daysDiff < 7) {
    return date.toLocaleDateString(locale, {
      weekday: "short"
    });
  }

  return date.toLocaleDateString(locale, {
    day: "2-digit",
    month: "short"
  });
};